"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PlusCircleSymbolIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "#FFF",
      className: "svg-fill-secondary",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M.605 6.57a1 1 0 111.999 0 1 1 0 01-2 0",
        transform: "translate(-2 -3) translate(2 3)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9.945 19.89C4.462 19.89 0 15.43 0 9.947a1 1 0 112 0c0 4.38 3.564 7.945 7.945 7.945s7.945-3.564 7.945-7.945S14.326 2 9.945 2a7.943 7.943 0 00-6.024 2.765A1 1 0 112.405 3.46 9.943 9.943 0 019.945 0c5.483 0 9.945 4.462 9.945 9.946s-4.462 9.945-9.945 9.945",
        transform: "translate(-2 -3) translate(2 3)"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M1.863 10a.9.9 0 01-.9-.9V1.176a.9.9 0 111.799 0V9.1a.9.9 0 01-.899.9",
      mask: "url(#mask-2)",
      transform: "translate(-2 -3) translate(7 7) translate(3 .725)",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M0 1.137a.9.9 0 01.9-.9h7.924c.497 0 .902.403.902.9s-.405.9-.902.9H.9a.9.9 0 01-.9-.9",
      mask: "url(#mask-4)",
      transform: "translate(-2 -3) translate(7 7) translate(0 4.725)",
      className: "svg-fill-primary"
    })]
  })]
});

PlusCircleSymbolIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(PlusCircleSymbolIcon);

exports.default = _default;